import { render, staticRenderFns } from "./communication-table.vue?vue&type=template&id=c4ba6d00&scoped=true&"
import script from "./communication-table.vue?vue&type=script&lang=js&"
export * from "./communication-table.vue?vue&type=script&lang=js&"
import style0 from "./communication-table.vue?vue&type=style&index=0&id=c4ba6d00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ba6d00",
  null
  
)

export default component.exports